import { c as _c } from "react/compiler-runtime";
import { useDate, useDestination, useHistory, usePassengerCount, useSubmit, useValidation } from "@website/accommodation-ui/villa-search/villa-search-panel/hooks";
import { PassengerCountInitialValuesType, VillaSearchPanelPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-panel.types";
import { VillaSearchPassengerCount } from "@website/accommodation-ui/villa-search/villa-search-passenger-count";
import { MaterialIcon } from "@website/icons/material";
import { AutoComplete } from "@website/ui/auto-complete";
import { Button } from "@website/ui/button";
import { Datepicker } from "@website/ui/datepicker";
import { FC } from "react";
export const VillaSearchPanel: FC<VillaSearchPanelPropertiesType> = properties => {
  const $ = _c(83);
  const {
    size,
    searchType,
    initialCityData,
    onClose,
    passengerCountInitialValues,
    datePickerInitialValues,
    handleSearchSubmit,
    searchSuggestion,
    searchAutocompleteFetcher,
    requireDestinationCoordinates
  } = properties;
  const t0 = passengerCountInitialValues as PassengerCountInitialValuesType;
  let t1;
  if ($[0] !== searchType || $[1] !== t0) {
    t1 = {
      initialValues: t0,
      searchType
    };
    $[0] = searchType;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    passengerCount,
    onSubmitPassengerCount,
    passengerCountList,
    passengerCountTitle,
    passengerCountResult,
    passengerCountValidation
  } = usePassengerCount(t1);
  const t2 = initialCityData?.title;
  let t3;
  if ($[3] !== searchAutocompleteFetcher || $[4] !== searchSuggestion || $[5] !== t2) {
    t3 = {
      cityTitleInitialValues: t2,
      searchSuggestion,
      searchAutocompleteFetcher
    };
    $[3] = searchAutocompleteFetcher;
    $[4] = searchSuggestion;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    selectedDestinationItem,
    selectedDestinationText,
    destinationQuery,
    onChangeDestination,
    onChangeDestinationQuery,
    onSelectDestination,
    destinationLoading,
    destinationListNormalized,
    DestinationNoResult
  } = useDestination(t3);
  const {
    date,
    onChangeDate
  } = useDate(datePickerInitialValues);
  const {
    historyListNormalized,
    addToHistory,
    onSelectHistory
  } = useHistory(onChangeDestination, requireDestinationCoordinates);
  let t4;
  if ($[7] !== date || $[8] !== initialCityData || $[9] !== searchType || $[10] !== selectedDestinationItem) {
    t4 = {
      acceptEmpty: true,
      selectedDestinationItem,
      date,
      initialDestinationItem: initialCityData,
      searchType
    };
    $[7] = date;
    $[8] = initialCityData;
    $[9] = searchType;
    $[10] = selectedDestinationItem;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const {
    destinationError,
    dateError,
    submitValidationCheck
  } = useValidation(t4);
  const {
    onSubmitClick,
    submitLoading
  } = useSubmit(selectedDestinationItem, date, passengerCount, addToHistory, submitValidationCheck, handleSearchSubmit, initialCityData);
  const t5 = `${searchType === "villa" ? "gap-8" : "gap-6"} relative mb-4 flex h-full flex-col lg:mb-0 lg:h-auto`;
  const t6 = searchType === "villa" ? "\u062A\u0639\u06CC\u06CC\u0646 \u0628\u0627\u0632\u0647 \u0627\u0642\u0627\u0645\u062A \u0648 \u0645\u0633\u0627\u0641\u0631\u0627\u0646" : "\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647";
  let t7;
  if ($[12] !== t6) {
    t7 = <h3 className="text-headline-6 lg:hidden">{t6}</h3>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onSubmitPassengerCount || $[15] !== passengerCountList || $[16] !== passengerCountResult || $[17] !== passengerCountTitle || $[18] !== passengerCountValidation || $[19] !== searchType) {
    t8 = (searchType === "city" || searchType === "category") && <div className="flex h-8 flex-row justify-between gap-2"><VillaSearchPassengerCount list={passengerCountList} onSubmit={onSubmitPassengerCount} result={passengerCountResult} searchType={searchType} size="dense" title={passengerCountTitle} validation={passengerCountValidation} /></div>;
    $[14] = onSubmitPassengerCount;
    $[15] = passengerCountList;
    $[16] = passengerCountResult;
    $[17] = passengerCountTitle;
    $[18] = passengerCountValidation;
    $[19] = searchType;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== onSubmitPassengerCount || $[22] !== passengerCountList || $[23] !== passengerCountResult || $[24] !== passengerCountValidation || $[25] !== searchType) {
    t9 = searchType === "home" && <div className="flex h-8 flex-row justify-between gap-2"><VillaSearchPassengerCount list={passengerCountList} onSubmit={onSubmitPassengerCount} result={passengerCountResult} searchType={searchType} title={"\u062A\u0639\u062F\u0627\u062F \u0645\u0633\u0627\u0641\u0631"} validation={passengerCountValidation} /></div>;
    $[21] = onSubmitPassengerCount;
    $[22] = passengerCountList;
    $[23] = passengerCountResult;
    $[24] = passengerCountValidation;
    $[25] = searchType;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const t10 = `flex flex-col gap-4 xl:flex-row ${searchType === "villa" ? "w-full" : ""}`;
  const t11 = `flex flex-col gap-4 lg:flex-row ${searchType === "city" ? "flex-1" : "w-full lg:items-center"}`;
  let t12;
  if ($[27] !== DestinationNoResult || $[28] !== destinationError || $[29] !== destinationListNormalized || $[30] !== destinationLoading || $[31] !== destinationQuery || $[32] !== historyListNormalized || $[33] !== onChangeDestinationQuery || $[34] !== onSelectDestination || $[35] !== onSelectHistory || $[36] !== searchType || $[37] !== selectedDestinationText || $[38] !== size) {
    t12 = searchType !== "villa" && <div className={`flex-[3] ${searchType === "category" ? "pointer-events-none opacity-60" : ""}`}><AutoComplete error={destinationError} fullWidth={true} parts={[{
        label: "\u0634\u0647\u0631 \u06CC\u0627 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647 \u0645\u0642\u0635\u062F",
        list: DestinationNoResult ? [] : destinationListNormalized,
        historyList: !DestinationNoResult && !destinationLoading ? historyListNormalized : [],
        historyTitle: "\u062C\u0633\u062A\u062C\u0648 \u0647\u0627\u06CC \u0627\u062E\u06CC\u0631",
        text: selectedDestinationText || "",
        onSelect: onSelectDestination,
        onSelectHistory,
        onChangeQuery: onChangeDestinationQuery,
        query: destinationQuery,
        loading: destinationLoading,
        NoResult: DestinationNoResult
      }]} size={size} /></div>;
    $[27] = DestinationNoResult;
    $[28] = destinationError;
    $[29] = destinationListNormalized;
    $[30] = destinationLoading;
    $[31] = destinationQuery;
    $[32] = historyListNormalized;
    $[33] = onChangeDestinationQuery;
    $[34] = onSelectDestination;
    $[35] = onSelectHistory;
    $[36] = searchType;
    $[37] = selectedDestinationText;
    $[38] = size;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  const t13 = `${searchType === "villa" ? "flex-auto lg:max-w-[312px]" : "flex-[2]"}`;
  const t14 = dateError.length > 0;
  const t15 = searchType === "villa" ? "0px" : "-16px";
  const t16 = searchType === "villa" ? "42px" : "-16px";
  const t17 = searchType === "villa" ? "start" : "end";
  const t18 = searchType === "villa" ? "dense" : "default";
  let t19;
  if ($[40] !== date) {
    t19 = date ?? [];
    $[40] = date;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== dateError || $[43] !== onChangeDate || $[44] !== t14 || $[45] !== t15 || $[46] !== t16 || $[47] !== t17 || $[48] !== t18 || $[49] !== t19) {
    t20 = <Datepicker acceptEmpty={true} error={t14} fromTitle={"\u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F"} fullWidth={true} gapHorizontal={t15} gapVertical={t16} helperText={dateError} mode="range" onChange={onChangeDate} position={t17} size={t18} toTitle={"\u062A\u0627\u0631\u06CC\u062E \u062E\u0631\u0648\u062C"} value={t19} />;
    $[42] = dateError;
    $[43] = onChangeDate;
    $[44] = t14;
    $[45] = t15;
    $[46] = t16;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== t13 || $[52] !== t20) {
    t21 = <div className={t13}>{t20}</div>;
    $[51] = t13;
    $[52] = t20;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  const t22 = `${searchType === "home" ? "static" : "absolute"} bottom-0 w-full lg:relative lg:w-[134px]`;
  const t23 = searchType === "villa" ? "secondary" : "primary";
  const t24 = searchType === "villa" ? "medium" : "x-large";
  let t25;
  if ($[54] !== onSubmitClick || $[55] !== submitLoading || $[56] !== t23 || $[57] !== t24) {
    t25 = <Button color={t23} fullWidth={true} loading={submitLoading} onClick={onSubmitClick} size={t24}>بروزرسانی جستجو</Button>;
    $[54] = onSubmitClick;
    $[55] = submitLoading;
    $[56] = t23;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== t22 || $[60] !== t25) {
    t26 = <div className={t22}>{t25}</div>;
    $[59] = t22;
    $[60] = t25;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  const t27 = `absolute left-0 top-0 mr-auto hidden text-center ltr:ml-auto ${searchType === "villa" ? "xl:mt-0" : ""} ${searchType === "home" ? "lg:hidden" : "lg:block"}`;
  let t28;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <MaterialIcon name="close" />;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== onClose) {
    t29 = <Button StartIcon={t28} color="neutral" onClick={onClose} size="small" variant="text" />;
    $[63] = onClose;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== t27 || $[66] !== t29) {
    t30 = <div className={t27}>{t29}</div>;
    $[65] = t27;
    $[66] = t29;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t11 || $[69] !== t12 || $[70] !== t21 || $[71] !== t26 || $[72] !== t30) {
    t31 = <div className={t11}>{t12}{t21}{t26}{t30}</div>;
    $[68] = t11;
    $[69] = t12;
    $[70] = t21;
    $[71] = t26;
    $[72] = t30;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== t10 || $[75] !== t31) {
    t32 = <div className={t10}>{t31}</div>;
    $[74] = t10;
    $[75] = t31;
    $[76] = t32;
  } else {
    t32 = $[76];
  }
  let t33;
  if ($[77] !== t32 || $[78] !== t5 || $[79] !== t7 || $[80] !== t8 || $[81] !== t9) {
    t33 = <div className={t5}>{t7}{t8}{t9}{t32}</div>;
    $[77] = t32;
    $[78] = t5;
    $[79] = t7;
    $[80] = t8;
    $[81] = t9;
    $[82] = t33;
  } else {
    t33 = $[82];
  }
  return t33;
};